<template>
  <footer class="app-footer no-print">
    <div class="app-footer__inner">
      <span class="app-footer__brand">Almacén</span>
      <span class="app-footer__meta">
        © {{ year }}
      </span>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>

<style scoped>
.app-footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 30;
  backdrop-filter: blur(18px);
  background: linear-gradient(
    180deg,
    rgba(15, 23, 42, 0.92),
    rgba(15, 23, 42, 0.98)
  );
  border-top: 1px solid rgba(148, 163, 184, 0.5);
}

.app-footer__inner {
  max-width: 1120px;
  margin: 0 auto;
  padding: 0.45rem 1.25rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 0.75rem;
  color: #94a3b8;
}

.app-footer__brand {
  font-weight: 500;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  font-size: 0.7rem;
}

@media (max-width: 640px) {
  .app-footer__inner {
    padding-inline: 0.9rem;
  }
}
</style>
